import { render, staticRenderFns } from "./warehouseGame.vue?vue&type=template&id=5033ac13&scoped=true&"
import script from "./warehouseGame.vue?vue&type=script&lang=js&"
export * from "./warehouseGame.vue?vue&type=script&lang=js&"
import style0 from "./warehouseGame.vue?vue&type=style&index=0&id=5033ac13&scoped=true&lang=css&"
import style1 from "./warehouseGame.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033ac13",
  null
  
)

export default component.exports